import React from 'react';
import styles from '../stylesheets/MetadataInfo.module.css';

const WhatsappProfileView = ({ formData, profilePicturePreview }) => {
  return (
    <div className={styles.viewContainer}>
      <div className={styles.profileRow}>
        {profilePicturePreview && (
          <img src={profilePicturePreview} alt="profile" className={styles.profileImage} />
        )}

        <div>
          <h4 className={styles.businessName}>Business Profile</h4>
          <p className={styles.profileHint}>
            This will be the WhatsApp display picture of your business
          </p>
        </div>
      </div>

      <hr className={styles.divider} />

      <h4 className={styles.sectionTitle}>Business Details</h4>

      <div className={styles.viewGrid}>
        <div>
          <p className={styles.label}>Description</p>
          <p className={styles.value}>{formData.description || '-'}</p>
        </div>

        <div>
          <p className={styles.label}>Address</p>
          <p className={styles.value}>{formData.address || '-'}</p>
        </div>

        <div>
          <p className={styles.label}>Email</p>
          <p className={styles.value}>{formData.email || '-'}</p>
        </div>

        <div>
          <p className={styles.label}>Category</p>
          <p className={styles.value}>{formData.vertical || '-'}</p>
        </div>

        <div>
          <p className={styles.label}>Website 1</p>
          <p className={styles.value}>{formData.websites?.[0]?.value || '-'}</p>
        </div>

        <div>
          <p className={styles.label}>Website 2</p>
          <p className={styles.value}>{formData.websites?.[1]?.value || '-'}</p>
        </div>

        <div>
          <p className={styles.label}>About</p>
          <p className={styles.value}>{formData.about || '-'}</p>
        </div>
      </div>
    </div>
  );
};

export default WhatsappProfileView;
